import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DropdownA from 'components/Dropdown/DropdownA';
import useTabStripRegistration from 'hooks/useTabStripRegistration';
import classes from './SelectC.module.scss';

const {
  arrayOf,
  func,
  number,
  string,
  shape,
} = PropTypes;

const SelectC = (props) => {
  const {
    tabs = [],
    selectedIndex,
    handleClick,
    handleSelect,
    identifier = '',
  } = props;

  const {
    registrationError,
  } = useTabStripRegistration({ identifier, className: '.k-tab-strip' });

  const tab = ({ title, color }, index) => { // eslint-disable-line react/prop-types
    const isActive = index === selectedIndex;

    return (
      <button
        type='button'
        key={index}
        className={classNames(
          classes.tab,
          {
            [classes.active]: (isActive),
            [`border-${color}`]: (isActive),
          },
        )}
        onClick={() => handleClick(index)}
        aria-label={title}
      >
        <div className={classNames(
          classes.tabContent,
          {
            [`border-${color}`]: (isActive),
          },
        )}
        >
          <div className={classes.tabTitle}>
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </div>
        </div>
      </button>
    );
  };

  const desktop = (
    <div className={classes.desktopContainer}>
      <div className={classes.tabs}>
        {tabs.map(tab)}
      </div>
    </div>
  );

  const listDisplay = (item) => (
    <span className={classes.optionWrapper}>
      <span
        className={classes.dropdownTitle}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
    </span>
  );

  const singleValue = (item) => (
    <span className={classes.singleValueWrapper}>
      <span
        className={classes.dropdownTitle}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
    </span>
  );

  const select = tabs.map((item) => ({
    ...item,
    label: item.title,
    renderSingleValue: singleValue(item),
    renderOption: listDisplay(item),
  }));

  const mobile = (
    <div className={classes.mobileContainer}>
      {select.length === 1 && <div className={classes.tabs}>{tab(tabs[0], 0)}</div>}
      {select.length > 1 && <DropdownA
        type='SelectD'
        options={select}
        defaultValue={select[selectedIndex]}
        onChange={handleSelect}
        renderOption='renderOption'
        renderSingleValue='renderSingleValue'
        {...props}
      />}
    </div>
  );

  return registrationError || (tabs.length > 0 &&
    <div className={classes.container} id={`TabStrip-${`${identifier ? `${identifier}-` : ''}select`}`}>
      {desktop}
      {mobile}
    </div>);
};

SelectC.propTypes = {
  /**
    Array of tab objects { type, title, color }
  */
  tabs: arrayOf(shape({
    type: string,
    title: string,
    color: string,
  })),
  /**
    Index of selected tab
  */
  selectedIndex: number.isRequired,
  /**
    Click handler method
  */
  handleClick: func,
  /**
    Select handler method
  */
  handleSelect: func,
  /**
    Identifier for component
  */
  indentifier: string,
};

export default SelectC;
